import path from 'ramda/src/path'

export default state => path(['staticData', 'shareUrl'], state)
